module.exports = __webpack_public_path__ + "static/media/ic_access_time.01daa7b5.png";